import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { formatCurrency, formatDate } from "@/lib/utils";
import type { DailyRevenuePoint } from "@/types";

interface DailyRevenueChartProps {
  data: DailyRevenuePoint[];
  busiestDay: DailyRevenuePoint | null;
}

export function DailyRevenueChart({
  data,
  busiestDay,
}: DailyRevenueChartProps) {
  if (data.length <= 1) {
    return null;
  }

  const maxRevenue = Math.max(0, ...data.map((row) => row.revenue));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Daily revenue</CardTitle>
        <CardDescription>
          {busiestDay
            ? `Busiest day: ${formatDate(busiestDay.date)} — ${formatCurrency(busiestDay.revenue)}`
            : "No revenue in this period"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex h-40 items-end gap-1">
          {data.map((row) => {
            const height =
              maxRevenue > 0
                ? Math.max(2, (row.revenue / maxRevenue) * 100)
                : 2;
            const isBest = busiestDay?.date === row.date && row.revenue > 0;

            return (
              <div
                key={row.date}
                className="flex flex-1 flex-col items-center"
                title={`${formatDate(row.date)} · ${formatCurrency(row.revenue)} · ${row.orderCount} orders`}
              >
                <div
                  className={
                    isBest
                      ? "w-full rounded-t bg-primary"
                      : "w-full rounded-t bg-primary/30"
                  }
                  style={{ height: `${height}%` }}
                />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
